import "@hotwired/turbo-rails";

// Entry point for the build script in your package.json

// Bootstrap
//import 'bootstrap/dist/css/bootstrap.min.css'
//import * as bootstrap from 'bootstrap';
//window.bootstrap = bootstrap;

// Mustache
//import Mustache from 'mustache'
//window.Mustache = Mustache

//import './styles/bootstrap_custom.css'

//import './src/lib/jquery'
//import './src/lib/jquery-ui';
//import './styles/lib/jquery-ui.css'

//import Inputmask from "inputmask"
//window.Inputmask = Inputmask

//import './styles/lib/slick.css';
//import slick from './src/lib/slick.js';
//window.slick = slick;

import './styles/application.css'

// Modal open/close + auth-code-form UX moved to Stimulus
// (controllers/modal_controller.js + controllers/auth_code_form_controller.js).

// App-wide: when the server flags a response with X-Acting-As-Blocked
// (superadmin write-block), dismiss any open Bootstrap modal. The backdrop
// lives on <body> outside the modal element, so it won't disappear by itself
// when the turbo-frame inside the modal gets cleared.
document.addEventListener("turbo:submit-end", function (event) {
  const headers = event.detail && event.detail.fetchResponse && event.detail.fetchResponse.response && event.detail.fetchResponse.response.headers
  if (!headers || headers.get("X-Acting-As-Blocked") !== "1") return

  alert("Действия запрещены: вы в режиме просмотра под другой ролью.")

  document.querySelectorAll('.modal.show').forEach(function (el) {
    el.classList.remove('show')
    el.style.display = 'none'
    el.setAttribute('aria-hidden', 'true')
    el.removeAttribute('aria-modal')
    if (window.bootstrap && window.bootstrap.Modal) {
      const inst = window.bootstrap.Modal.getInstance(el)
      if (inst) inst.dispose()
    }
  })
  document.querySelectorAll('.modal-backdrop').forEach(function (el) { el.remove() })
  document.body.classList.remove('modal-open')
  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('padding-right')
})

import "./controllers"
